/**
 * Phase 6 — extracted helper for the Felix sidebar.open_category tool
 * dispatch so the integration test can pin it without booting the full
 * FelixChat component tree. The component switch in FelixChat.tsx now
 * delegates to this helper.
 *
 * Patent I anchor: this helper is the publisher half of the
 * Felix-driven nav-surface bridge. The subscriber half lives in
 * frontend/src/stores/sidebarStore.ts.
 */

// Loose shape so the helper can be called from the FelixChat tool-
// dispatch switch where `action` is the full FelixAction union. The
// `type` field is informational; the publisher path only reads
// `params.category_id`.
export interface SidebarOpenCategoryAction {
  type: string;
  params: Record<string, unknown>;
}

export interface SidebarOpenCategoryResult {
  status: "success" | "error";
  detail: string;
}

/** Publish the `ftl.felix.sidebar.open_category` window event with the
 * right detail. Returns a result envelope the FelixChat tool-dispatch
 * switch records on its action list. */
export function handleSidebarOpenCategoryAction(input: {
  action: SidebarOpenCategoryAction;
}): SidebarOpenCategoryResult {
  const categoryId = input.action.params.category_id as string | undefined;
  if (!categoryId) {
    return {
      status: "error",
      detail: "sidebar.open_category requires category_id",
    };
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("ftl.felix.sidebar.open_category", {
        detail: {
          category_id: categoryId,
          source: "felix_chat",
        },
      }),
    );
  }
  return {
    status: "success",
    detail: `Opened ${categoryId} shelf`,
  };
}
